// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"09d40589","544":"c2575945","889":"bf13ebbe"}[chunkId] + ".chunk.css";
};